/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect } from 'react';
import { useCommandPaletteIsOpen } from '@jira/compal__command-palette/src/controllers/command-palette/index.tsx';
import { createSwitchController } from '@jira/platform__controllers-switch/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { OverrideContainerComponent } from '@atlassian/react-sweet-state';
import type { MenuId } from '../../types.tsx';

const { SwitchContainer, useSwitch } = createSwitchController<MenuId | undefined>(
	'atlassian-navigation-top-menus',
);

export const TopMenusContainer: OverrideContainerComponent<unknown> = SwitchContainer;
const useTopMenusBase: (active?: MenuId | undefined) => readonly [
	boolean,
	{
		readonly on: () => void;
		readonly off: () => void;
		readonly toggle: () => void;
	},
] = useSwitch;

const useTopMenuWithCommandPalette: typeof useTopMenusBase = (props) => {
	const switcher = useTopMenusBase(props);
	const [{ isOpen: isCommandPaletteOpen }] = useCommandPaletteIsOpen();

	const [isSwitchOpen, { off }] = switcher;

	useEffect(() => {
		if (isSwitchOpen && isCommandPaletteOpen) off();
	}, [isCommandPaletteOpen, isSwitchOpen, off]);

	return switcher;
};

export { useTopMenuWithCommandPalette as useTopMenus };

export type UseTopMenusType = typeof useTopMenusBase;
